import MenuClosedMessage from "./MenuClosedMessage";

export default MenuClosedMessage;
